import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Star, ExternalLink } from 'lucide-react';
import { Button } from './ui/Button';
const tools = [{
  name: 'Linear',
  category: 'Project Management',
  rating: 4.9,
  logo: 'L'
}, {
  name: 'Notion',
  category: 'Knowledge Base',
  rating: 4.8,
  logo: 'N'
}, {
  name: 'Figma',
  category: 'Design',
  rating: 4.9,
  logo: 'F'
}, {
  name: 'Slack',
  category: 'Communication',
  rating: 4.7,
  logo: 'S'
}, {
  name: 'Vercel',
  category: 'Deployment',
  rating: 4.9,
  logo: 'V'
}, {
  name: 'Supabase',
  category: 'Database',
  rating: 4.8,
  logo: 'S'
}];
export function FeaturedTools() {
  return <section className="py-24 bg-slate-50" data-id="element-30">
      <div className="container mx-auto px-6" data-id="element-31">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12 gap-6" data-id="element-32">
          <div data-id="element-33">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-34">
              Featured Tools on{' '}
              <a href="https://keyanalyzer.com/" className="text-blue-600 hover:underline" data-id="element-35">
                Keyanalyzer
              </a>
            </h2>
            <p className="text-lg text-slate-600 max-w-xl" data-id="element-36">
              Explore our curated selection of top-rated software across various
              categories on{' '}
              <a href="https://keyanalyzer.com/" className="text-blue-600 hover:underline" data-id="element-37">
                Keyanalyzer.com
              </a>
              .
            </p>
          </div>
          <a href="https://keyanalyzer.com/" className="hidden md:inline-flex items-center justify-center px-4 py-2 border border-slate-300 shadow-sm text-sm font-medium rounded-md text-slate-700 bg-white hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-38">
            View All Tools <ArrowRight className="w-4 h-4 ml-2" data-id="element-39" />
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-40">
          {tools.map((tool, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} whileHover={{
          scale: 1.02,
          y: -5
        }} className="bg-white p-6 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 border border-slate-100 group cursor-pointer" data-id="element-41">
              <div className="flex items-start justify-between mb-4" data-id="element-42">
                <div className="w-12 h-12 rounded-xl bg-slate-100 flex items-center justify-center text-xl font-bold text-slate-700 group-hover:bg-slate-900 group-hover:text-white transition-colors" data-id="element-43">
                  {tool.logo}
                </div>
                <div className="flex items-center gap-1 bg-slate-50 px-2 py-1 rounded-lg border border-slate-100" data-id="element-44">
                  <Star className="w-3 h-3 text-yellow-400 fill-yellow-400" data-id="element-45" />
                  <span className="text-sm font-medium text-slate-700" data-id="element-46">
                    {tool.rating}
                  </span>
                </div>
              </div>

              <h3 className="text-xl font-bold text-slate-900 mb-1" data-id="element-47">
                {tool.name}
              </h3>
              <p className="text-sm text-slate-500 mb-6" data-id="element-48">{tool.category}</p>

              <a href="https://keyanalyzer.com/" className="flex items-center text-sm font-medium text-blue-600 opacity-0 group-hover:opacity-100 transition-opacity -translate-x-2 group-hover:translate-x-0 duration-300" data-id="element-49">
                View Details on Keyanalyzer{' '}
                <ArrowRight className="w-4 h-4 ml-1" data-id="element-50" />
              </a>
            </motion.div>)}
        </div>

        <div className="mt-12 text-center md:hidden" data-id="element-51">
          <a href="https://keyanalyzer.com/" className="w-full inline-flex items-center justify-center px-4 py-2 border border-slate-300 shadow-sm text-sm font-medium rounded-md text-slate-700 bg-white hover:bg-slate-50" data-id="element-52">
            View All Tools <ArrowRight className="w-4 h-4 ml-2" data-id="element-53" />
          </a>
        </div>
      </div>
    </section>;
}